import { useState } from 'react'
import { Badge } from '@/components/ui/badge'
import { Popover, PopoverContent, PopoverTrigger } from '@src/components/ui/popover'
import { DamageState } from '../types/riskProfileSelected.types'
import { orderDamageStates } from '../utils/riskProfile.utils'
import { CATEGORY_COLOURS, CATEGORY_TEXT_COLOURS } from '../constants/riskProfile.constants'

type RiskProfileMultiDamageStatesProps = {
  highestDamageState: DamageState
  damageStates: DamageState[]
  rowId: string
}

function capitalizeFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

function getVulnerabilityBgColor(vulnerability: string): string {
  return CATEGORY_COLOURS[capitalizeFirst(vulnerability)] ?? '#9ca3af'
}

function getVulnerabilityTextColor(vulnerability: string): string {
  return CATEGORY_TEXT_COLOURS[capitalizeFirst(vulnerability)] ?? '#fff'
}

export const RiskProfileMultiDamageStates = ({
  highestDamageState,
  damageStates,
  rowId,
}: RiskProfileMultiDamageStatesProps) => {
  const [showMoreDamageStates, setShowMoreDamageStates] = useState<string | null>(null)

  return (
    <div className="flex flex-wrap gap-1">
      <Badge
        key={highestDamageState}
        variant="secondary"
        className="text-xs capitalize"
        style={{
          backgroundColor: getVulnerabilityBgColor(highestDamageState),
          color: getVulnerabilityTextColor(highestDamageState),
        }}
      >
        {highestDamageState}
      </Badge>
      {damageStates.length > 1 ? (
        <Popover open={showMoreDamageStates === rowId}>
          <PopoverTrigger asChild>
            <Badge
              key={'more-than-one-damage-state'}
              variant="secondary"
              className="text-xs bg-secondary text-secondary-foreground cursor-default"
              onMouseEnter={() => setShowMoreDamageStates(rowId)}
              onMouseLeave={() => setShowMoreDamageStates(null)}
            >
              + {damageStates.length - 1} more
            </Badge>
          </PopoverTrigger>
          <PopoverContent className="w-[320px] p-4" align="start">
            <h6 className="font-[400]">All damage states ({damageStates.length})</h6>
            <div className="flex flex-wrap pt-3 gap-2">
              {orderDamageStates(damageStates).map((damageState, index) => (
                <Badge
                  key={damageState + index}
                  variant="secondary"
                  className="text-xs capitalize"
                  style={{
                    backgroundColor: getVulnerabilityBgColor(damageState),
                    color: getVulnerabilityTextColor(damageState),
                  }}
                >
                  {damageState}
                </Badge>
              ))}
            </div>
          </PopoverContent>
        </Popover>
      ) : null}
    </div>
  )
}
